import React from "react";
import { FlexContainer } from "src/components";
import { TextLabel } from "../../components/style";

export default function TableAnalytics(props) {
    const { opens, clicks } = props;
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
            }}
        >
            <FlexContainer>
                <TextLabel fontWeight="bold" marginBottom="0px">
                    {`${opens}%`}
                </TextLabel>
                <TextLabel>Opens</TextLabel>
            </FlexContainer>
            <FlexContainer>
                <TextLabel fontWeight="bold" marginBottom="0px">
                    {`${clicks}%`}
                </TextLabel>
                <TextLabel>Clicks</TextLabel>
            </FlexContainer>
        </div>
    );
}
